/* unplugin-vue-components disabled */import { render } from "./LeftMenuItem.vue?vue&type=template&id=296e679c&scoped=true"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js"

import "./LeftMenuItem.vue?vue&type=style&index=0&id=296e679c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296e679c"]])

export default __exports__